import React, { useState } from 'react'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const usePasswordToggle = () => {
    const [visiblity,setVisible]=useState(false);

    const handler=()=>{setVisible(visiblity => !visiblity)}
    const Icon=visiblity? <VisibilityIcon onClick={handler}/>:<VisibilityOffIcon onClick={handler}/>
    const InputType=visiblity?"text":"password";

  return [InputType,Icon]
}

export default usePasswordToggle